export default [
  {
    path: 'overview',
    name: 'Overview',
    redirect : 'readme',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/Overview.vue'),
  },
  {
    path: 'readme',
    name: 'Readme',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/Readme.vue'),
  },
]
